/**
 * Composite grouping key for stats tabs (ids of different trackers must not collide).
 * The formula lives in shared (`campaignGroupKey`) so the Automation's
 * campaign groups are the SAME groups as this page's.
 * For Media Devoted | Created By Ciro Autiero
 */
import { campaignGroupKey } from '@trafficpulse/shared';

import type { TrackerEnum } from '@trafficpulse/shared';

export type TrafficProviderKind = TrackerEnum;

export interface TrafficGroupableCampaign {
  id: number;
  trafficProvider?: TrafficProviderKind | null;
  trafficCampaignId?: string | null;
  /** Legacy API field; treated like trafficCampaignId when trafficCampaignId is absent */
  voluumCampaignId?: string | null;
}

export function trafficCampaignGroupKey(c: TrafficGroupableCampaign): string {
  return campaignGroupKey({
    wiserId: c.id,
    trafficProvider: c.trafficProvider,
    trafficCampaignId: c.trafficCampaignId ?? c.voluumCampaignId,
  });
}
